// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.featured-projects_container_XT1_A {
    margin-bottom: 8px;
}

.featured-projects_opener-container_e_WDe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    opacity: 0.8;
}

.featured-projects_opener-container_e_WDe:hover {
    opacity: 1;
}

.featured-projects_opener-content_X9NR3 {
    background-color: var(--ui-modal-background);
    padding: 4px;
    border: 1px solid var(--ui-black-transparent);
    box-shadow: 0 0 8px 0 var(--shadow);
}

.featured-projects_projects_QVH4S {
    position: relative;
    height: 155px;
}

.featured-projects_projects_QVH4S.featured-projects_transition_kEliT {
    transition: .2s height;
}

.featured-projects_projects_QVH4S.featured-projects_opened_yT3Bh {
    height: 310px;
}

.featured-projects_footer_d62hE {
    
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-featured-projects/featured-projects.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,YAAY;IACZ,6CAA6C;IAC7C,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;;AAEA","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n    margin-bottom: 8px;\n}\n\n.opener-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    opacity: 0.8;\n}\n\n.opener-container:hover {\n    opacity: 1;\n}\n\n.opener-content {\n    background-color: var(--ui-modal-background);\n    padding: 4px;\n    border: 1px solid var(--ui-black-transparent);\n    box-shadow: 0 0 8px 0 var(--shadow);\n}\n\n.projects {\n    position: relative;\n    height: 155px;\n}\n\n.projects.transition {\n    transition: .2s height;\n}\n\n.projects.opened {\n    height: 310px;\n}\n\n.footer {\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `featured-projects_container_XT1_A`,
	"opener-container": `featured-projects_opener-container_e_WDe`,
	"openerContainer": `featured-projects_opener-container_e_WDe`,
	"opener-content": `featured-projects_opener-content_X9NR3`,
	"openerContent": `featured-projects_opener-content_X9NR3`,
	"projects": `featured-projects_projects_QVH4S`,
	"transition": `featured-projects_transition_kEliT`,
	"opened": `featured-projects_opened_yT3Bh`,
	"footer": `featured-projects_footer_d62hE`
};
export default ___CSS_LOADER_EXPORT___;
